import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MessageService } from "primeng/api";
import { InvestorDetail } from "src/models/investor";
import { IGenericResponse } from "src/models/genericModels";
import { InvestorService } from "src/services/investor.service";

@Component({
  selector: "app-update-personal-info-modal",
  templateUrl: "./update-personal-info-modal.component.html",
  styleUrls: ["./update-personal-info-modal.component.scss"],
  providers: [MessageService],
})
export class UpdatePersonalInfoModalComponent implements OnInit {
  personalInfoForm: FormGroup;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private investorService: InvestorService,
    public dialogRef: MatDialogRef<UpdatePersonalInfoModalComponent>,
    public messageService: MessageService,
    @Inject(MAT_DIALOG_DATA) public data: { investorDetail: InvestorDetail }
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    // Parse the date string to Date object if it exists
    let dobDate = null;
    if (this.data.investorDetail.info.dob) {
      // Fix timezone issue by parsing the date string manually
      const [year, month, day] = this.data.investorDetail.info.dob
        .split("-")
        .map(Number);
      // JavaScript months are 0-based (0 = January, 11 = December)
      dobDate = new Date(year, month - 1, day);
    }

    this.personalInfoForm = this.fb.group({
      id: [this.data.investorDetail.user.id, Validators.required],
      name: [this.data.investorDetail.user.name, Validators.required],
      mobile_number: [
        this.data.investorDetail.user.mobile_number,
        [Validators.required, Validators.pattern(/^[0-9]{10}$/)],
      ],
      gender: [this.data.investorDetail.user.gender, Validators.required],
      dob: [dobDate, Validators.required],
      aadhaar: [
        this.data.investorDetail.info.aadhaar,
        [Validators.required, Validators.pattern(/^[0-9]{12}$/)],
      ],
    });
  }

  onSubmit() {
    if (this.personalInfoForm.invalid) {
      this.personalInfoForm.markAllAsTouched();
      return;
    }

    // Format form data before sending to API
    const formData = { ...this.personalInfoForm.value };

    // Format date to YYYY-MM-DD
    if (formData.dob instanceof Date) {
      const year = formData.dob.getFullYear();
      const month = String(formData.dob.getMonth() + 1).padStart(2, "0");
      const day = String(formData.dob.getDate()).padStart(2, "0");
      formData.dob = `${year}-${month}-${day}`;
    }

    this.loading = true;
    this.investorService.updateInvestorDetail(formData).subscribe({
      next: (res: IGenericResponse) => {
        this.messageService.add({
          severity: "success",
          summary: "Success",
          detail: res.message,
        });
        this.loading = false;
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: err.error.message || "An error occurred",
        });
        this.loading = false;
      },
    });
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
